"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderContainer = exports.StyledCircle = exports.IconPath = exports.CircleSvg = exports.rotateCircle = exports.animateCircle = void 0;
var styled_components_1 = __importStar(require("styled-components"));
exports.animateCircle = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% { stroke-dashoffset: 200px; }\n  50% { stroke-dashoffset: 76px; }\n  100% { stroke-dashoffset: 200px; }\n"], ["\n  0% { stroke-dashoffset: 200px; }\n  50% { stroke-dashoffset: 76px; }\n  100% { stroke-dashoffset: 200px; }\n"])));
exports.rotateCircle = styled_components_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% { transform: rotate(-90deg); }\n  50% { transform: rotate(90deg); }\n  100% { transform: rotate(630deg); }\n"], ["\n  0% { transform: rotate(-90deg); }\n  50% { transform: rotate(90deg); }\n  100% { transform: rotate(630deg); }\n"])));
exports.CircleSvg = styled_components_1.default.svg(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  animation: ", " 2000ms linear infinite;\n  left: 0;\n  position: absolute;\n  top: 0;\n"], ["\n  animation: ", " 2000ms linear infinite;\n  left: 0;\n  position: absolute;\n  top: 0;\n"])), exports.rotateCircle);
var getIconPathFillColor = function (_a) {
    var theme = _a.theme, variant = _a.variant;
    switch (variant) {
        case ('secondary'):
            return theme.colors.gray.s700;
        case ('alt'):
            return theme.colors.gray.s300;
        default:
            return theme.colors.main.base;
    }
};
exports.IconPath = styled_components_1.default.path(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  fill: ", ";\n  transform-origin: 50% 50%;\n"], ["\n  fill: ", ";\n  transform-origin: 50% 50%;\n"])), getIconPathFillColor);
var getStyledCircleStrokeColor = function (_a) {
    var theme = _a.theme, variant = _a.variant;
    if (theme !== undefined && Object.keys(theme).length > 0) {
        switch (variant) {
            case ('secondary'):
                return theme.colors.gray.s800;
            case ('alt'):
                return theme.colors.gray.s300;
            default:
                return theme.colors.main.base;
        }
    }
    return '#e1e1e4';
};
exports.StyledCircle = styled_components_1.default.circle(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  animation: ", " 2000ms linear infinite;\n  fill: transparent;\n  stroke-dasharray: 200px;\n  stroke-dashoffset: 100px;\n  stroke-linecap: round;\n  stroke-width: 2;\n  stroke: ", ";\n  transform-origin: 50% 50%;\n"], ["\n  animation: ", " 2000ms linear infinite;\n  fill: transparent;\n  stroke-dasharray: 200px;\n  stroke-dashoffset: 100px;\n  stroke-linecap: round;\n  stroke-width: 2;\n  stroke: ", ";\n  transform-origin: 50% 50%;\n"])), exports.animateCircle, getStyledCircleStrokeColor);
exports.LoaderContainer = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  height: ", ";\n  position: relative;\n  width: ", ";\n"], ["\n  height: ", ";\n  position: relative;\n  width: ", ";\n"])), function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var width = _a.width;
    return width;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
